export default {"src":"/_next/static/media/chapter-2-icon-circular.84c5aa3f.svg","height":137,"width":137,"blurWidth":0,"blurHeight":0};